import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-breadcrumb-button',
  templateUrl: './breadcrumb-button.component.html',
  styleUrls: ['./breadcrumb-button.component.scss']
})
export class BreadcrumbButtonComponent implements OnInit {

  @Input()
  titleStringKey: string;

  @Input()
  iconClass: string;

  constructor() { }

  ngOnInit() {
  }

}
